import { SCREEN_NEEDS } from './screen-needs.js';
import { screenPermissionKeys } from './screen-permission-keys.js';
import { SCREENS } from './screens.js';
const SHOWN_KEYS = new Set(SCREENS.flatMap(screenPermissionKeys));
function moduleOf(permission) {
    return permission.split(':')[0] ?? '';
}
/** For each View key a granted screen needs, the modules needing it; a screen held at View only because another needs it brings in nothing, and hidden keys never count as holding more. */
export function neededBy(granted) {
    const held = new Set(granted);
    const seen = [...SCREEN_NEEDS.keys()].filter((module) => held.has(`${module}:view`));
    const neededSees = new Set(seen.flatMap((module) => SCREEN_NEEDS.get(module) ?? []));
    const holdsMoreThanSee = (module) => [...held].some((permission) => moduleOf(permission) === module &&
        !permission.endsWith(':view') &&
        SHOWN_KEYS.has(permission));
    const result = new Map();
    for (const module of seen) {
        if (neededSees.has(`${module}:view`) && !holdsMoreThanSee(module))
            continue;
        for (const permission of SCREEN_NEEDS.get(module) ?? []) {
            result.set(permission, [...(result.get(permission) ?? []), module]);
        }
    }
    return result;
}
//# sourceMappingURL=needed-by.js.map